import { render, staticRenderFns } from "./StiBonus.vue?vue&type=template&id=4334db21&scoped=true"
import script from "./StiBonus.vue?vue&type=script&lang=js"
export * from "./StiBonus.vue?vue&type=script&lang=js"
import style0 from "./StiBonus.vue?vue&type=style&index=0&id=4334db21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4334db21",
  null
  
)

export default component.exports